import { render } from "./TaskGroups.vue?vue&type=template&id=415e2778&scoped=true"
import script from "./TaskGroups.vue?vue&type=script&lang=js"
export * from "./TaskGroups.vue?vue&type=script&lang=js"

import "./TaskGroups.vue?vue&type=style&index=0&id=415e2778&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415e2778"]])

export default __exports__